import { render, staticRenderFns } from "./chapterlistdialog.vue?vue&type=template&id=87494d8c&scoped=true"
import script from "./chapterlistdialog.vue?vue&type=script&lang=js"
export * from "./chapterlistdialog.vue?vue&type=script&lang=js"
import style0 from "./chapterlistdialog.vue?vue&type=style&index=0&id=87494d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87494d8c",
  null
  
)

export default component.exports